"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBoxComponent = void 0;
Object.defineProperty(exports, "actions", {
  enumerable: true,
  get: function get() {
    return _actions.default;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "events", {
  enumerable: true,
  get: function get() {
    return _events.default;
  }
});
exports.mapStateToProps = exports.mapDispatchToProps = void 0;
Object.defineProperty(exports, "reducers", {
  enumerable: true,
  get: function get() {
    return _reducers.default;
  }
});
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _redux = require("redux");
var _actions = _interopRequireDefault(require("./actions"));
var _reducers = _interopRequireDefault(require("./reducers"));
var _style = _interopRequireDefault(require("./style.scss"));
var _message = _interopRequireDefault(require("./message"));
var _events = _interopRequireDefault(require("./events"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MessageBox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(MessageBox, _PureComponent);
  var _super = _createSuper(MessageBox);
  function MessageBox(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MessageBox);
    _this = _super.call(this, props);
    _this.onClearMessage = _this.onClearMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderMessage = _this.renderMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(MessageBox, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;
      if (!this.props.static) {
        _lodash.default.map(this.props.id, function (id) {
          return _this2.props.actions.clearMessageBox(id);
        });
      }
    }
  }, {
    key: "onClearMessage",
    value: function onClearMessage(message) {
      this.props.actions.clearMessage(this.props.id, message.id);
    }
  }, {
    key: "renderMessage",
    value: function renderMessage(message) {
      return /*#__PURE__*/_react.default.createElement(_message.default, {
        key: message.id,
        onClearMessage: this.onClearMessage,
        data: message,
        static: this.props.static
      });
    }
  }, {
    key: "render",
    value: function render() {
      var classKey = this.props.static ? 'toast-container' : 'message-box';
      var CLASS_NAME = _lodash.default.get(_style.default, classKey, classKey);
      var classModule = "".concat(this.props.moduleName, " ").concat(CLASS_NAME);
      var messageComponents = (0, _lodash.default)(this.props.messages).filter(function (message) {
        return !message.hide;
      }).map(this.renderMessage).value();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classModule
      }, messageComponents);
    }
  }]);
  return MessageBox;
}(_react.PureComponent);
exports.MessageBoxComponent = MessageBox;
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var module = "".concat(ownProps.moduleName || '', "MessageBoxReducer");
  return {
    id: _lodash.default.flatten([ownProps.id]),
    messages: (0, _lodash.default)([ownProps.id])
    // Convert multidimensional arrays to array
    .flatten().map(function (id) {
      return _lodash.default.map(state[module].get(id), function (item) {
        return item;
      });
    }).flatten().value()
  };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(Object.assign({}, _objectSpread({}, _actions.default)), dispatch)
  };
};
exports.mapDispatchToProps = mapDispatchToProps;
MessageBox.propTypes = {
  actions: _propTypes.default.shape({
    clearMessageBox: _propTypes.default.func.isRequired,
    clearMessage: _propTypes.default.func.isRequired
  }).isRequired,
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]).isRequired,
  messages: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    text: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.func]),
    type: _propTypes.default.oneOf(['success', 'error', 'info', 'warning']),
    duration: _propTypes.default.number,
    staticClose: _propTypes.default.bool,
    autoDismiss: _propTypes.default.bool
  })),
  /**
   * Use `moduleName` to specify a prefix for the Reducer name in the consuming module.
   * Given `Communications` as the `moduleName` value, the exported Reducer will be accessed
   * via the name `CommunicationsMessageBoxReducer`.
   */
  moduleName: _propTypes.default.string,
  static: _propTypes.default.bool
};
MessageBox.defaultProps = {
  messages: [],
  moduleName: '',
  static: false
};
var _default = MessageBox;
exports.default = _default;